{
  "REPORT": {
    "HEADER": "Gespräche",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_AGENT_REPORTS": "Agenten-Berichte herunterladen",
    "DATA_FETCHING_FAILED": "Daten konnten nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
    "SUMMARY_FETCHING_FAILED": "Zusammenfassung konnte nicht abgerufen werden. Bitte versuchen Sie es später erneut.",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Auflösungsanzahl",
        "DESC": "( Gesamt )"
      },
      "BOT_RESOLUTION_COUNT": {
        "NAME": "Auflösungsanzahl",
        "DESC": "( Gesamt )"
      },
      "BOT_HANDOFF_COUNT": {
        "NAME": "Übergabezählung",
        "DESC": "( Gesamt )"
      },
      "REPLY_TIME": {
        "NAME": "Wartezeit des Kunden",
        "TOOLTIP_TEXT": "Die Wartezeit beträgt {metricValue} (basierend auf {conversationCount} Antworten)",
        "DESC": ""
      }
    },
    "DATE_RANGE_OPTIONS": {
      "LAST_7_DAYS": "Letzten 7 Tage",
      "LAST_30_DAYS": "Letzte 30 Tage",
      "THIS_MONTH": "Dieser Monat",
      "LAST_MONTH": "Letzter Monat",
      "LAST_3_MONTHS": "Die letzten 3 Monate",
      "LAST_6_MONTHS": "Die letzten 6 Monate",
      "LAST_YEAR": "Letztes Jahr",
      "CUSTOM_DATE_RANGE": "Benutzerdefinierter Zeitraum",
      "TODAY": "Heute",
      "YESTERDAY": "Gestern"
    },
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    },
    "GROUP_BY_FILTER_DROPDOWN_LABEL": "Gruppieren nach",
    "DURATION_FILTER_LABEL": "Dauer",
    "GROUPING_OPTIONS": {
      "DAY": "Tag",
      "WEEK": "Woche",
      "MONTH": "Monat",
      "YEAR": "Jahr"
    },
    "GROUP_BY_DAY_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      }
    ],
    "GROUP_BY_WEEK_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      },
      {
        "id": 2,
        "groupBy": "Woche"
      }
    ],
    "GROUP_BY_MONTH_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      },
      {
        "id": 2,
        "groupBy": "Woche"
      },
      {
        "id": 3,
        "groupBy": "Monat"
      }
    ],
    "GROUP_BY_YEAR_OPTIONS": [
      {
        "id": 1,
        "groupBy": "Tag"
      },
      {
        "id": 2,
        "groupBy": "Woche"
      },
      {
        "id": 3,
        "groupBy": "Monat"
      }
    ],
    "BUSINESS_HOURS": "Öffnungszeiten",
    "FILTER_ACTIONS": {
      "CLEAR_FILTER": "Filter löschen",
      "EMPTY_LIST": "Keine Ergebnisse gefunden"
    },
    "DRILLDOWN": {
      "RESULT_COUNT_CONVERSATION": "Konversationen: {count}",
      "RESULT_COUNT_MESSAGE": "Nachrichten: {count}",
      "EMPTY": "Für diesen Balken wurden keine Einträge gefunden.",
      "ERROR": "Einträge konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
      "LOAD_MORE": "Mehr laden",
      "PREVIOUS_BUCKET": "Vorheriger Balken",
      "NEXT_BUCKET": "Nächster Balken",
      "UNKNOWN_CONTACT": "Unbekannter Kontakt",
      "UNKNOWN_INBOX": "Unbekannter Eingang",
      "UNASSIGNED_AGENT": "Nicht zugewiesen",
      "NO_MESSAGE_CONTENT": "Kein Nachrichteninhalt",
      "MESSAGE_CREATED_AT": "Nachricht erstellt am {time}",
      "EVENT_OCCURRED_AT": "Ereignis eingetreten am {time}",
      "INCOMING_MESSAGE": "Eingehende Nachricht",
      "OUTGOING_MESSAGE": "Ausgehende Nachricht",
      "VIEW_ALL": "In Konversationen anzeigen",
      "VIEW_ALL_LIMIT": "Nur Balken mit höchstens {limit} Konversationen lassen sich in der Konversationsliste öffnen.",
      "HIDDEN_COUNT": "Nicht angezeigt, weil Sie kein Mitglied ihres Eingangs sind: {count}"
    },
    "PAGINATION": {
      "RESULTS": "Showing {start} to {end} of {total} results",
      "PER_PAGE_TEMPLATE": "{size} / page"
    }
  },
  "AGENT_REPORTS": {
    "HEADER": "Agenten-Übersicht",
    "DESCRIPTION": "Easily track agent performance with key metrics such as conversations, response times, resolution times, and resolved cases. Click an agent’s name to learn more.",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_AGENT_REPORTS": "Agenten-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Agent auswählen",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "LABEL_REPORTS": {
    "HEADER": "Label-Übersicht",
    "DESCRIPTION": "Verfolgen Sie die Leistung der Labels mit wichtigen Kennzahlen wie Unterhaltungen, Antwortzeiten, Lösungszeiten und gelösten Fällen.",
    "LOADING_CHART": "Diagrammdaten laden...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_LABEL_REPORTS": "Label-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Label auswählen",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "INBOX_REPORTS": {
    "HEADER": "Posteingangsübersicht",
    "DESCRIPTION": "Quickly view your inbox performance with key metrics like conversations, response times, resolution times, and resolved cases—all in one place. Click an inbox name for more details.",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_INBOX_REPORTS": "Agenten-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Eingang auswählen",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "TEAM_REPORTS": {
    "HEADER": "Team-Übersicht",
    "DESCRIPTION": "Get a snapshot of your team’s performance with essential metrics, including conversations, response times, resolution times, and resolved cases. Click a team name for more details.",
    "LOADING_CHART": "Diagrammdaten laden ...",
    "NO_ENOUGH_DATA": "Wir haben nicht genügend Datenpunkte erhalten, um einen Bericht zu erstellen. Bitte versuchen Sie es später erneut.",
    "DOWNLOAD_TEAM_REPORTS": "Team-Berichte herunterladen",
    "FILTER_DROPDOWN_LABEL": "Team auswählen",
    "METRICS": {
      "CONVERSATIONS": {
        "NAME": "Konversationen",
        "DESC": "( Gesamt )"
      },
      "INCOMING_MESSAGES": {
        "NAME": "Eingehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "OUTGOING_MESSAGES": {
        "NAME": "Ausgehende Nachrichten",
        "DESC": "( Gesamt )"
      },
      "FIRST_RESPONSE_TIME": {
        "NAME": "Erste Antwortzeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Zeit bis zur ersten Reaktion beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_TIME": {
        "NAME": "Lösungszeit",
        "DESC": "( Durchschnitt )",
        "INFO_TEXT": "Gesamtzahl der Konversationen, die für die Berechnung verwendet wurden:",
        "TOOLTIP_TEXT": "Die Lösungszeit beträgt {metricValue} (basierend auf {conversationCount} Konversationen)"
      },
      "RESOLUTION_COUNT": {
        "NAME": "Lösungsanzahl",
        "DESC": "( Gesamt )"
      }
    },
    "DATE_RANGE": [
      {
        "id": 0,
        "name": "Letzte 7 Tage"
      },
      {
        "id": 1,
        "name": "Letzte 30 Tage"
      },
      {
        "id": 2,
        "name": "Letzte 3 Monate"
      },
      {
        "id": 3,
        "name": "Letzte 6 Monate"
      },
      {
        "id": 4,
        "name": "Letztes Jahr"
      },
      {
        "id": 5,
        "name": "Benutzerdefinierter Zeitraum"
      }
    ],
    "CUSTOM_DATE_RANGE": {
      "CONFIRM": "Übernehmen",
      "PLACEHOLDER": "Zeitraum auswählen"
    }
  },
  "CSAT_REPORTS": {
    "HEADER": "CSAT-Berichte",
    "NO_RECORDS": "Es sind keine Antworten zu CSAT Umfragen verfügbar.",
    "DOWNLOAD": "CSAT-Berichte herunterladen",
    "DOWNLOAD_FAILED": "CSAT-Berichte konnten nicht heruntergeladen werden",
    "FILTERS": {
      "AGENTS": {
        "PLACEHOLDER": "Agenten wählen"
      }
    },
    "TABLE": {
      "HEADER": {
        "CONTACT_NAME": "Kontakt",
        "AGENT_NAME": "Zugewiesener Agent",
        "RATING": "Bewertung",
        "FEEDBACK_TEXT": "Feedback-Kommentar"
      }
    },
    "METRIC": {
      "TOTAL_RESPONSES": {
        "LABEL": "Antworten gesamt",
        "TOOLTIP": "Anzahl aller gesammelten Antworten"
      },
      "SATISFACTION_SCORE": {
        "LABEL": "Zufriedenheitswert",
        "TOOLTIP": "Anzahl der positiven Antworten / Anzahl aller Antworten * 100"
      },
      "RESPONSE_RATE": {
        "LABEL": "Antwortrate",
        "TOOLTIP": "Anzahl aller Antworten / Anzahl der gesendeten CSAT-Umfrage * 100"
      }
    }
  },
  "BOT_REPORTS": {
    "HEADER": "Bot-Berichte",
    "METRIC": {
      "TOTAL_CONVERSATIONS": {
        "LABEL": "Anzahl der Konversationen",
        "TOOLTIP": "Gesamtzahl der vom Bot bearbeiteten Konversationen"
      },
      "TOTAL_RESPONSES": {
        "LABEL": "Gesamtanzahl Antworten",
        "TOOLTIP": "Gesamtzahl der vom Bot gesendeten Antworten"
      },
      "RESOLUTION_RATE": {
        "LABEL": "Lösungsrate",
        "TOOLTIP": "Gesamtzahl der vom Bot gelösten Konversationen / Gesamtzahl der vom Bot bearbeiteten Konversationen * 100"
      },
      "HANDOFF_RATE": {
        "LABEL": "Übergaberate",
        "TOOLTIP": "Gesamtzahl der an Agenten übergebenen Konversationen / Gesamtzahl der vom Bot bearbeiteten Konversationen * 100"
      },
      "CONVERSATION_COUNT": {
        "LABEL": "Anzahl der Unterhaltungen",
        "TOOLTIP": "Gesamtzahl der Unterhaltungen mit Bot-Nachrichten"
      },
      "OUTGOING_COUNT": {
        "LABEL": "Anzahl der Antworten",
        "TOOLTIP": "Gesamtzahl der ausgehenden Nachrichten"
      },
      "MESSAGE_COUNT": {
        "LABEL": "Anzahl der KI-Antworten",
        "TOOLTIP": "Gesamtzahl der vom Bot gesendeten Antwortnachrichten"
      },
      "COPILOT_COUNT": {
        "LABEL": "Anzahl vorbereiteter Antworten",
        "TOOLTIP": "Gesamtzahl der vom Bot für Agenten vorbereiteten Copilot-Vorschläge"
      },
      "SUCCESS_RATE": {
        "LABEL": "Von KI gelöst",
        "TOOLTIP": "Prozentsatz der Unterhaltungen, die von der KI ohne Agentenübergabe gelöst wurden"
      },
      "RESOLVE_TIME": {
        "LABEL": "Lösungszeit",
        "TOOLTIP": "Mediane Zeit von der ersten Kundennachricht bis zur letzten Bot/Agent-Nachricht"
      }
    },
    "GROUP_BY": {
      "LABEL": "Gruppieren nach",
      "NONE": "Nicht gruppieren",
      "INBOXES": "Posteingänge",
      "LABELS": "Labels"
    },
    "GROUPED": {
      "CHART_TITLE": "Verteilung nach Gruppe",
      "BACK_TO_ALL": "Alle anzeigen",
      "TABLE": {
        "INBOX": "Posteingang",
        "LABEL": "Label",
        "CONVERSATIONS": "Unterhaltungen",
        "MESSAGES": "Nachrichten",
        "MESSAGES_TOOLTIP": "Gesamtzahl der ausgehenden Nachrichten",
        "AI_MESSAGES": "KI-Antworten",
        "AI_MESSAGES_TOOLTIP": "Gesamtzahl der KI-Antworten, gefolgt von der Anzahl positiver und negativer Bewertungen durch Endnutzer",
        "THUMBS_UP_TOOLTIP": "Anzahl der KI-Antworten, die von Endnutzern positiv (Daumen hoch) bewertet wurden",
        "THUMBS_DOWN_TOOLTIP": "Anzahl der KI-Antworten, die von Endnutzern negativ (Daumen runter) bewertet wurden",
        "AI_PERCENTAGE": "KI %",
        "AI_PERCENTAGE_TOOLTIP": "Anteil der KI-Antworten an allen Nachrichten in dieser Gruppe",
        "PREPARED": "Vorbereitete Antworten",
        "PERCENTAGE": "%",
        "PERCENTAGE_TOOLTIP": "Anteil der Nachrichten an allen Nachrichten dieser Gruppe",
        "BOT_RESPONSES": "KI-Antworten %",
        "SUGGESTION_USED": "Verwendete Antworten",
        "SUGGESTION_USED_TOOLTIP": "Prozentsatz der in dieser Gruppe vorbereiteten Antworten, die von Agenten verwendet wurden",
        "SUGGESTION_NOT_USED": "Unverwendete Antworten",
        "SUGGESTION_NOT_USED_TOOLTIP": "Prozentsatz der Nachrichten in dieser Gruppe, für die eine vorbereitete Antwort vorlag, aber nicht verwendet wurde"
      },
      "NOTES": {
        "TITLE": "Wie die Metriken berechnet werden",
        "CONVERSATIONS": "Anzahl der Unterhaltungen mit mindestens einer ausgehenden Nachricht im ausgewählten Zeitraum.",
        "MESSAGES": "Gesamtzahl der im ausgewählten Zeitraum gesendeten ausgehenden (nicht privaten) Nachrichten. Dies umfasst sowohl KI-generierte als auch von Menschen geschriebene Nachrichten.",
        "PERCENTAGE": "Anteil der Nachrichten dieser Gruppe an allen ausgehenden Nachrichten über alle Gruppen hinweg.",
        "AI_MESSAGES": "Anzahl der automatisch vom KI-Bot gesendeten ausgehenden Nachrichten (ohne vorbereitete Antworten für Agenten). Die Zahlen in Klammern zeigen, wie viele dieser Antworten von Endnutzern positiv (Daumen hoch) und negativ (Daumen runter) bewertet wurden.",
        "BOT_RESPONSES_PCT": "Anteil der KI-Antworten dieser Gruppe an allen ausgehenden Nachrichten in dieser Gruppe.",
        "PREPARED": "Anzahl der vom KI-Bot im ausgewählten Zeitraum für Agenten erzeugten Copilot-Vorschläge (vorbereitete Antworten). Dies sind private Nachrichten, die nur für Agenten sichtbar sind und nicht als ausgehende Nachrichten zählen, weshalb diese Zahl nicht mit der Spalte Nachrichten korrelieren muss.",
        "SUGGESTION_USED": "Prozentsatz der in dieser Gruppe vorbereiteten Antworten, die von Agenten verwendet wurden. Dies kann nicht mit der Anzahl der vorbereiteten Antworten korrelieren, da auch Vorschläge aus früheren Perioden enthalten sein können.",
        "SUGGESTION_NOT_USED": "Prozentsatz der ausgehenden Nachrichten in dieser Gruppe, bei denen ein Copilot-Vorschlag verfügbar war, der Agent aber ohne dessen Verwendung geantwortet hat. Wird nur gezählt, wenn der Agent tatsächlich eine Antwort gesendet hat. Dies kann nicht mit der Anzahl der vorbereiteten Antworten korrelieren, da auch Vorschläge aus früheren Perioden enthalten sein können."
      }
    }
  },
  "OVERVIEW_REPORTS": {
    "HEADER": "Übersicht",
    "LIVE": "Live",
    "ACCOUNT_CONVERSATIONS": {
      "HEADER": "Offene Konversationen",
      "LOADING_MESSAGE": "Konversationsdaten werden geladen...",
      "OPEN": "Öffnen",
      "UNATTENDED": "Unbeaufsichtigt",
      "UNASSIGNED": "Nicht zugewiesen",
      "PENDING": "Ausstehend"
    },
    "CONVERSATION_HEATMAP": {
      "HEADER": "Gesprächsprotokoll",
      "NO_CONVERSATIONS": "Keine Konversation",
      "CONVERSATION": "{count} Konversation",
      "CONVERSATIONS": "{count} Konversationen",
      "DOWNLOAD_REPORT": "Bericht herunterladen"
    },
    "AGENT_CONVERSATIONS": {
      "HEADER": "Konversationen von Agenten",
      "LOADING_MESSAGE": "Agent-Daten werden geladen...",
      "NO_AGENTS": "Es existieren keine Konversationen von Agenten",
      "TABLE_HEADER": {
        "AGENT": "Agent",
        "OPEN": "Öffnen",
        "UNATTENDED": "Unbeaufsichtigt",
        "STATUS": "Status"
      }
    },
    "TEAM_CONVERSATIONS": {
      "ALL_TEAMS": "All Teams",
      "HEADER": "Conversations by teams",
      "LOADING_MESSAGE": "Loading team metrics...",
      "NO_TEAMS": "There is no data available",
      "TABLE_HEADER": {
        "TEAM": "Team",
        "OPEN": "Öffnen",
        "UNATTENDED": "Unbeaufsichtigt",
        "STATUS": "Status"
      }
    },
    "AGENT_STATUS": {
      "HEADER": "Agentenstatus",
      "ONLINE": "Online",
      "BUSY": "Beschäftigt",
      "OFFLINE": "Offline"
    }
  },
  "DAYS_OF_WEEK": {
    "SUNDAY": "Sonntag",
    "MONDAY": "Montag",
    "TUESDAY": "Dienstag",
    "WEDNESDAY": "Mittwoch",
    "THURSDAY": "Donnerstag",
    "FRIDAY": "Freitag",
    "SATURDAY": "Samstag"
  },
  "SLA_REPORTS": {
    "HEADER": "SLA-Berichte",
    "NO_RECORDS": "SLA-angewandte Unterhaltungen sind nicht verfügbar.",
    "LOADING": "Lade SLA-Daten...",
    "DOWNLOAD_SLA_REPORTS": "SLA-Berichte herunterladen",
    "DOWNLOAD_FAILED": "SLA-Berichte konnten nicht heruntergeladen werden",
    "DROPDOWN": {
      "ADD_FIlTER": "Filter hinzufügen",
      "CLEAR_ALL": "Alle löschen",
      "CLEAR_FILTER": "Filter löschen",
      "EMPTY_LIST": "Keine Ergebnisse gefunden",
      "NO_FILTER": "Keine Filter verfügbar",
      "SEARCH": "Suchfilter",
      "INPUT_PLACEHOLDER": {
        "SLA": "SLA-Name",
        "AGENTS": "Agentenname",
        "INBOXES": "Posteingangsname",
        "LABELS": "Labelname",
        "TEAMS": "Teamname"
      },
      "SLA": "SLA-Richtlinie",
      "INBOXES": "Posteingang",
      "AGENTS": "Agent",
      "LABELS": "Label",
      "TEAMS": "Team"
    },
    "WITH": "mit",
    "METRICS": {
      "HIT_RATE": {
        "LABEL": "Trefferquote",
        "TOOLTIP": "Prozentsatz der erstellten SLAs, die erfolgreich abgeschlossen wurden"
      },
      "NO_OF_MISSES": {
        "LABEL": "Anzahl der Verfehlungen",
        "TOOLTIP": "Gesamtanzahl der SLA-Verfehlungen in einem bestimmten Zeitraum"
      },
      "NO_OF_CONVERSATIONS": {
        "LABEL": "Anzahl der Konversationen",
        "TOOLTIP": "Gesamtzahl der Konversationen mit SLA"
      }
    },
    "TABLE": {
      "HEADER": {
        "POLICY": "Richtlinie",
        "CONVERSATION": "Konversation",
        "AGENT": "Agent"
      },
      "VIEW_DETAILS": "Details anzeigen"
    }
  },
  "SUMMARY_REPORTS": {
    "SUBTOTAL": "Zwischensumme",
    "NO_TEAM": "Kein Team",
    "GROUP_BY_TEAMS": "Nach Teams gruppieren",
    "INBOX": "Posteingang",
    "AGENT": "Agent",
    "TEAM": "Team",
    "LABEL": "Label",
    "AVG_RESOLUTION_TIME": "Avg. Resolution Time",
    "AVG_FIRST_RESPONSE_TIME": "Avg. First Response Time",
    "AVG_REPLY_TIME": "Avg. Customer Waiting Time",
    "RESOLUTION_COUNT": "Auflösungsanzahl",
    "CONVERSATIONS": "Anzahl der Konversationen",
    "TOTAL": "Gesamt",
    "OUTGOING_CHATS": "Ausgehende Chats",
    "OUTGOING_EMAILS": "Ausgehende E-Mails",
    "PHONE_CALLS": "Telefonanrufe",
    "INBOUND_CALLS": "Eingehende Anrufe",
    "OUTBOUND_CALLS": "Ausgehende Anrufe",
    "TOTAL_ACTIVITIES": "Aktivitäten gesamt",
    "ONLINE_TIME": "Online-Zeit",
    "QUEUE_AVAILABLE_TIME": "Verfügbarkeitszeit in Warteschlange",
    "TOOLTIPS": {
      "OUTGOING_CHATS": "Anzahl der von diesem Agenten gesendeten ausgehenden Nachrichten",
      "OUTGOING_EMAILS": "Anzahl der von diesem Agenten gesendeten ausgehenden E-Mails",
      "PHONE_CALLS": "Gesamtzahl der diesem Agenten zugewiesenen Telefonanrufe (Summe der eingehenden und ausgehenden Anrufe)",
      "TOTAL_ACTIVITIES": "Gesamtzahl der Aktivitäten: eingehende Anrufe + ausgehende Anrufe + ausgehende Chats + ausgehende E-Mails",
      "INBOUND_CALLS": "Anzahl der diesem Agenten zugewiesenen eingehenden Telefonanrufe",
      "OUTBOUND_CALLS": "Anzahl der diesem Agenten zugewiesenen ausgehenden Telefonanrufe",
      "AVG_FIRST_RESPONSE_TIME": "Durchschnittliche Zeit von der Erstellung der Unterhaltung bis zur ersten Agentenantwort in diesem Agenten zugewiesenen Unterhaltungen",
      "AVG_RESOLUTION_TIME": "Durchschnittliche Zeit von der Erstellung bis zur Lösung in diesem Agenten zugewiesenen Unterhaltungen",
      "AVG_REPLY_TIME": "Durchschnittliche Wartezeit der Kunden zwischen ihrer Nachricht und der Antwort des Agenten in diesem Agenten zugewiesenen Unterhaltungen",
      "ONLINE_TIME": "Gesamtzeit, in der der Agent im ausgewählten Zeitraum online oder beschäftigt war",
      "QUEUE_AVAILABLE_TIME": "Gesamtzeit, in der der Agent im ausgewählten Zeitraum in Telefonwarteschlangen verfügbar war"
    }
  },
  "PHONE_REPORTS": {
    "HEADER": "Telefonberichte",
    "DESCRIPTION": "Verfolgen Sie Telefonanruf-Metriken mit detaillierten Einblicken zu eingehenden und ausgehenden Anrufen, gruppiert nach Agent oder Posteingang für eine umfassende Analyse.",
    "AGENT_HEADER": "Telefonberichte - Nach Agent",
    "INBOX_HEADER": "Telefonberichte - Nach Posteingang",
    "DOWNLOAD_BUTTON": "Telefonberichte herunterladen",
    "DOWNLOAD_PHONE_REPORTS": "Telefonberichte herunterladen",
    "GROUP_BY": {
      "LABEL": "Gruppieren nach",
      "AGENT": "Agent",
      "INBOX": "Posteingang"
    },
    "TABLE": {
      "AGENT_NAME": "Agentenname",
      "INBOX_NAME": "Posteingangsname",
      "TOTAL_CALLS": "Gesamt",
      "INBOUND_CALLS": "Eingehend",
      "OUTBOUND_CALLS": "Ausgehend",
      "FAILED_OUTBOUND_CALLS": "Fehlgeschlagen ausgehend",
      "AVG_AGENT_HANDLED_DURATION": "Ø Dauer",
      "TOTAL_AGENT_HANDLED_DURATION": "Gesamtdauer",
      "AVG_RINGING_TIME": "Ø Klingelzeit",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Erfolg %",
      "UNIQUE_CALLERS": "Eindeutige Anrufer",
      "UNIQUE_CALLED_CONTACTS": "Eindeutig Angerufen",
      "UNANSWERED_MISSED_CALLS": "Verpasst ohne Rückruf",
      "UNANSWERED_MISSED_PERCENTAGE": "Verpasst ohne Rückruf %",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Verpasst ohne Rückruf, unzureichend zurückgerufen",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Verpasst ohne Rückruf, unzureichend zurückgerufen %"
    },
    "TOOLTIPS": {
      "TOTAL_CALLS": "Gesamtzahl aller Anrufe (einschließlich nicht verbundener)",
      "INBOUND_CALLS": "Anzahl verbundener Anrufe",
      "OUTBOUND_CALLS": "Anzahl aller ausgehenden Anrufe (einschließlich nicht verbundener)",
      "FAILED_OUTBOUND_CALLS": "Anzahl der ausgehenden Anrufe, die nicht verbunden werden konnten",
      "AVG_AGENT_HANDLED_DURATION": "Durchschnittliche Dauer der von Agenten bearbeiteten Anrufe",
      "TOTAL_AGENT_HANDLED_DURATION": "Gesamtdauer aller von Agenten bearbeiteten Anrufe",
      "AVG_RINGING_TIME": "Durchschnittliche Klingelzeit vor Annahme der Anrufe",
      "CONNECTED_OUTBOUND_PERCENTAGE": "Prozentsatz der erfolgreich verbundenen ausgehenden Anrufe",
      "UNIQUE_CALLERS": "Anzahl eindeutiger Kontakte, die eingehende Anrufe getätigt haben",
      "UNIQUE_CALLED_CONTACTS": "Anzahl eindeutiger Kontakte, die über ausgehende Anrufe angerufen wurden",
      "UNANSWERED_MISSED_CALLS": "Anzahl verpasster Anrufe, bei denen kein erfolgreicher Rückruf getätigt wurde (Anruf verbunden). Kann Anrufe enthalten, die innerhalb des Geschäftstages noch bearbeitet werden können",
      "UNANSWERED_MISSED_PERCENTAGE": "Prozentsatz eindeutiger Anrufer, deren Anrufe ohne Rückruf verpasst wurden (verpasste nicht beantwortete Anrufe / eindeutige Anrufer)",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_CALLS": "Anzahl verpasster Anrufe mit weniger als 2 Rückrufversuchen. Kann Anrufe enthalten, die innerhalb des Geschäftstages noch bearbeitet werden können",
      "INSUFFICIENTLY_HANDLED_UNANSWERED_MISSED_PERCENTAGE": "Prozentsatz eindeutiger Anrufer mit weniger als 2 Rückrufversuchen ((verpasst ohne Rückruf - ausreichend bearbeitet) / eindeutige Anrufer)"
    },
    "EMPTY_STATE": {
      "TITLE": "Keine Telefonanrufdaten verfügbar",
      "MESSAGE": "Im ausgewählten Datumsbereich sind keine Telefonanrufe vorhanden. Versuchen Sie, die Filter oder den Zeitraum anzupassen."
    }
  }
}
